import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const FoodVendorsList = () => {
  const navigate = useNavigate();

  // Hardcoded restaurants data
  const restaurants = [
    {
      id: 1,
      name: 'Pizzeria Da Mario',
      category: 'Pizzeria',
      description: 'Le migliori pizze di Macerata',
      phone: '+39 0733 123456',
      slug: 'pizzeria-da-mario',
      image: '/assets/images/CardFoodAttivita-1771263858499.png'
    },
    {
      id: 2,
      name: 'Trattoria Il Borgo',
      category: 'Ristorante',
      description: 'Cucina tradizionale marchigiana',
      phone: '+39 0733 654321',
      slug: 'trattoria-il-borgo',
      image: '/assets/images/CardFoodAttivita-1771263858499.png'
    }
  ];

  const handleCardClick = (slug) => {
    navigate(`/food/Macerata/${slug}`);
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Sticky Navbar */}
      <nav className="sticky top-0 z-50 bg-white shadow-sm">
        <div className="max-w-[1200px] mx-auto px-6 h-16 flex items-center justify-between">
          {/* Logo */}
          <a
            href="https://app.cliccami.net/#/home-servizi"
            className="flex items-center h-full py-2 transition-opacity hover:opacity-80"
          >
            <img
              src="/assets/images/logo-1771244548080.png"
              alt="Cliccami Logo"
              className="h-full w-auto object-contain"
            />
          </a>

          {/* Navigation Links */}
          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/home-servizi"
              className="text-gray-700 hover:text-gray-900 transition-colors font-medium"
            >
              Home
            </Link>
            <a
              href="https://app.cliccami.net/#/food/Macerata"
              className="text-gray-700 hover:text-gray-900 transition-colors font-medium"
            >
              Ristoranti
            </a>
            <a
              href="#contatti"
              className="text-gray-700 hover:text-gray-900 transition-colors font-medium"
            >
              Contatti
            </a>
          </div>

          {/* Profile Button */}
          <button
            onClick={() => navigate('/user-dashboard')}
            className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-medium"
          >
            Profilo
          </button>
        </div>
      </nav>

      {/* Main Content */}
      <div className="max-w-[1200px] mx-auto px-6 py-12">
        {/* Header Section */}
        <div className="mb-12">
          <Link
            to="/food"
            className="inline-flex items-center gap-2 text-gray-600 hover:text-gray-900 transition-colors mb-6 font-medium"
          >
            <Icon name="ArrowLeft" size={20} />
            <span>Torna alle città</span>
          </Link>
          
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-3">
            Macerata
          </h1>
          
          <p className="text-lg text-gray-600">
            Scegli un esercente per ordinare
          </p>
        </div>

        {/* Restaurant Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {restaurants?.map((restaurant) => (
            <button
              key={restaurant?.id}
              onClick={() => handleCardClick(restaurant?.slug)}
              className="bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-xl hover:-translate-y-1 transition-all duration-300 text-left group"
            >
              {/* Image */}
              <div className="w-full aspect-video overflow-hidden bg-gray-100">
                <img
                  src={restaurant?.image}
                  alt={restaurant?.name}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
              </div>

              {/* Content */}
              <div className="p-6">
                {/* Category Badge */}
                <span className="inline-block px-3 py-1 bg-blue-100 text-blue-700 text-sm font-medium rounded-full mb-3">
                  {restaurant?.category}
                </span>

                {/* Restaurant Name */}
                <h3 className="text-2xl font-bold text-gray-900 mb-2">
                  {restaurant?.name}
                </h3>

                {/* Description */}
                <p className="text-gray-600 mb-4">
                  {restaurant?.description}
                </p>

                {/* Footer with Phone and Arrow */}
                <div className="flex items-center justify-between pt-4 border-t border-gray-200">
                  <div className="flex items-center gap-2 text-gray-600">
                    <Icon name="Phone" size={18} />
                    <span className="text-sm">{restaurant?.phone}</span>
                  </div>
                  <Icon
                    name="ArrowRight"
                    size={24}
                    className="text-gray-400 group-hover:text-blue-600 group-hover:translate-x-1 transition-all duration-300"
                  />
                </div>
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FoodVendorsList;